import { fetchSeasons, type Season } from '@@fire-b2b/app/composables/seasons/fetchSeasons'
import type { GQLResult } from '@fire-b2b/utils/gql'
import { defineStore } from 'pinia'

export const useSeasonsStore = defineStore('seasons', () => {
  const isLoaded = ref(false)
  const seasons = ref<Season[]>([])

  async function loadSeasons(): Promise<GQLResult<void>> {
    if (isLoaded.value) {
      return ok()
    }

    const seasonsResult = await fetchSeasons()

    if (isErr(seasonsResult)) {
      return seasonsResult
    }

    seasons.value = seasonsResult.data
    isLoaded.value = true

    return ok()
  }

  return {
    isLoaded,
    seasons,
    loadSeasons,
  }
})
